import { render } from "./PpcAuthTable.vue?vue&type=template&id=33b0ef9b"
import script from "./PpcAuthTable.vue?vue&type=script&lang=js"
export * from "./PpcAuthTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__